import { Button } from '@mui/material';
import React, { useRef } from 'react';
import { useState } from 'react';
import toast from 'react-hot-toast';
import PinInput from 'react-pin-input';
import http from '../services/httpService';


function Gromolink() {

    const [disabled, setDisabled] = useState(true);

    const [value, setValue] = useState('');

    const [gromoValue, setGromoValue] = useState('');

    const handleChange = (e) => {
        setValue(e.target.value);
    }

    const submit = () => {
        if (value.length > 8 || value.length < 8) {
            toast.error(value + "shouldn't be less than or graeter than 8 digits");
        }
        else if (value.length === 8) {
            http.get(`/encode_gromo?code=${value}`).then(res => {
                setGromoValue(res.data.data);
            })
        }
    }

    const [copySuccess, setCopySuccess] = useState('Copy');

    function copyToClipboard(e) {
        // Get the text field
        var copyText = gromoValue;
        // Select the text field
        // copyText.select();
        // copyText.setSelectionRange(0, 99999); // For mobile devices

        // Copy the text inside the text field
        // navigator.clipboard.writeText(copyText.value);

        navigator.clipboard.writeText(copyText)

        setCopySuccess('Copied!');
    };




    return (
        <div>
            <h2>Create Gromo Link</h2>

            {/* <PinInput 
        length={8} 
        initialValue=""
        secret 
        onChange={(value, index) => {}} 
        type="numeric" 
        inputMode="number"
        style={{padding: '10px'}}  
        // inputStyle={{borderColor: 'red'}}
        // inputFocusStyle={{borderColor: 'blue'}}
        onComplete={(value, index) => {}}
        autoSelect={true}
        // regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
        regexCriteria='none'
    /> */}


            <div>
                <label>Enter Gromo Code</label>
                <input type='text' onChange={handleChange} style={{ display: 'block', marginTop: 20, marginBottom: 20, outline: 0, border: '1px solid transparent', borderBottom: '2px solid #000', width: 200 }} />

                {value.length !== 8 ? <Button variant='contained' colr='primary' disabled={disabled} onClick={submit}>Create</Button>
                    :
                    <Button variant='contained' colr='primary' onClick={submit}>Create</Button>
                }

                <p id='text'>
                    {gromoValue}
                </p>

                {gromoValue ?
                    <Button variant='contained' colr='primary' onClick={copyToClipboard}>{copySuccess}</Button>
                    : ""
                }

            </div>

        </div>
    )
}

export default Gromolink